const PRODUCTION_PANEL_URL = 'https://panel.aniphys.ru/';

type PanelLocation = Pick<Location, 'hostname' | 'origin' | 'port'>;

function isLoopback(hostname: string): boolean {
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1';
}

export function isPanelHostname(hostname: string): boolean {
  return hostname === 'panel.aniphys.ru';
}

export function panelHref(location: PanelLocation = window.location): string {
  if (isLoopback(location.hostname) && location.port === '5173') {
    const url = new URL(location.origin);
    url.port = '5174';
    url.pathname = '/';
    url.search = '';
    url.hash = '';
    return url.href;
  }
  return PRODUCTION_PANEL_URL;
}
